// extracted by css-extract-rspack-plugin
export default {"compressedAssigneeAvatar":"CompressedAssigneeAnchor-module__compressedAssigneeAvatar__YcZfr"};